/* eslint-disable */
// @ts-nocheck
import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import type { CustomCalculationRecord } from '../../types/customCalculations';
import type { HttpResponse } from '../../types/HttpResponse.type';
import type { ActionNamespaceConstants, NamespaceAction } from '../../../redux/types';
import type { CustomCalculation } from '../../../../../shared/types';

export const CUSTOM_CALCULATIONS_PATH = '/v1/analytics/calculations';
const NAMESPACE = 'GET_CUSTOM_CALCULATIONS' as const;
const GetCustomCalculations = new ReduxAsyncAction(NAMESPACE);

type GetCustomCalculationsResponse = HttpResponse<(CustomCalculation & { type: string })[]>;
GetCustomCalculations.registerRequest(async () => {
  const response: GetCustomCalculationsResponse = await dash_api.get(CUSTOM_CALCULATIONS_PATH);
  return (response.data || []).map(({ type, ...calculation }) => ({ ...calculation, isAppLevel: type === 'app' }));
});
export const GET_CUSTOM_CALCULATIONS: ActionNamespaceConstants<typeof NAMESPACE> = GetCustomCalculations.constants;
export const getCustomCalculations = GetCustomCalculations.request;
export type GetCustomCalculationsAction = NamespaceAction<typeof NAMESPACE, CustomCalculationRecord[]>;

export const SET_CUSTOM_CALCULATION = 'SET_CUSTOM_CALCULATION';
export function setCustomCalculation(payload: CustomCalculationRecord) {
  return {
    type: SET_CUSTOM_CALCULATION,
    data: payload,
  };
}
export type SetCustomCalculationAction = { type: typeof SET_CUSTOM_CALCULATION; data: CustomCalculationRecord };

export const REMOVE_CUSTOM_CALCULATION = 'REMOVE_CUSTOM_CALCULATION';
export function removeCustomCalculation(payload: Pick<CustomCalculationRecord, 'id'>) {
  return {
    type: REMOVE_CUSTOM_CALCULATION,
    data: payload,
  };
}
export type RemoveCustomCalculationAction = {
  type: typeof REMOVE_CUSTOM_CALCULATION;
  data: Pick<CustomCalculationRecord, 'id'>;
};

export type CustomCalculationAction =
  | GetCustomCalculationsAction
  | SetCustomCalculationAction
  | RemoveCustomCalculationAction;
